import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { useWallet } from "@solana/wallet-adapter-react";
import { useEffect, useState } from "react";
import "./wallet.css";

function PHWallet() {
  const wallet = useWallet();
  const [isMobile, setIsMobile] = useState(false);
  const [phantomAvailable, setPhantomAvailable] = useState(false);

  // Check screen size on load and resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Detect Phantom Wallet
  useEffect(() => {
    const checkPhantom = () => {
      setTimeout(() => {
        if (window.solana && window.solana.isPhantom) {
          setPhantomAvailable(true);
        } else {
          setPhantomAvailable(false);
        }
      }, 1000); // Wait 1 second for Phantom to load
    };

    checkPhantom();
  }, []);

  // Handle mobile deep linking
  const handleMobileConnect = () => {
    if (!phantomAvailable) {
      window.location.href = "https://phantom.app/ul/v1/connect";
    }
  };
  // isMobile && !phantomAvailable ? (
  //   <button
  //     onClick={handleMobileConnect}
  //     style={{
  //       backgroundColor: "#06b6d4",
  //       color: "#fff",
  //       fontWeight: "bold",
  //       borderRadius: "2rem",
  //       border: "2px solid #000000",
  //       fontSize: "0.8rem",
  //       width: "100%",
  //       textAlign: "center",
  //       height: "44px",
  //       placeContent: "center",
  //       fontFamily: "dalek, sans-serif",
  //       textTransform: "uppercase",
  //     }}
  //   >
  //     Open Phantom App
  //   </button>
  // ) : 
  return (
    <>
      <WalletModalProvider>
        {(
          <WalletMultiButton
            style={{
              backgroundColor: "#06b6d4",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: "2rem",
              border: "2px solid #000000",
              fontSize: "0.8rem",
              width: "100%",
              textAlign: "center",
              height: "44px",
              placeContent: "center",
              fontFamily: "dalek, sans-serif",
              textTransform: "uppercase",
            }}
          >
            {!wallet?.connected && (isMobile ? "Connect" : "Connect Wallet")}
          </WalletMultiButton>
        )}
      </WalletModalProvider>
    </>
  );
}

export default PHWallet;
